import { ReactElement } from 'react';
import { Svg } from '@hopskipdrive/react-components';
import { Handshake } from '@mui/icons-material';

import { ContactIcon, OrganizerIcon } from '../../../shared/components/Icons';

import { StyledCarePartnerIconChip, StyledIconChip } from './IconChip.styles';

interface IconChipProps {
  value: string;
  label?: string;
}

const IconChip = ({ value, label }: IconChipProps): ReactElement => {
  const lowerValue = value?.toLowerCase();

  // Special case for care partners
  if (lowerValue === 'riderassistant' || lowerValue === 'carepartnerdriver') {
    return <StyledCarePartnerIconChip label={label} icon={<Handshake />} data-testid="care-partner-chip" />;
  }

  const mapToIcon = () => {
    switch (lowerValue) {
      case 'rider':
      case 'passenger':
        return <Svg icon="sidebar_riders" />;
      case 'driver':
        return <Svg icon="directions-car-filled" />;
      case 'organizer':
        return <OrganizerIcon />;
      case 'client':
        return <Svg icon="school_building" />;
      case 'caregiver':
        return <ContactIcon />;
      default:
        return undefined;
    }
  };

  const mapToLabel = () => {
    switch (value) {
      case 'driver':
        return 'CareDriver';
      case 'caregiver':
        return 'CareGiver';
      default:
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  };

  return <StyledIconChip label={label ? label : mapToLabel()} icon={mapToIcon()} />;
};

export default IconChip;
